// Parse JSON out of an LLM reply. Models often wrap JSON in markdown code
// fences or add a sentence before/after it, so strip those before parsing.
// Returns null when no JSON can be recovered.
export const parseAiJson = (text) => {
    if (text == null) return null;
    if (typeof text !== 'string') return text;

    const fenced = text.match(/```(?:json)?\s*([\s\S]*?)```/i);
    const candidate = (fenced ? fenced[1] : text).trim();

    try {
        return JSON.parse(candidate);
    } catch (e) {
        // Fall back to the outermost array or object in the reply
        const start = candidate.search(/[[{]/);
        if (start === -1) return null;
        const closing = candidate[start] === '[' ? ']' : '}';
        const end = candidate.lastIndexOf(closing);
        if (end <= start) return null;
        try {
            return JSON.parse(candidate.slice(start, end + 1));
        } catch (e2) {
            return null;
        }
    }
};

// Parse a list of strings from an LLM reply. Uses JSON when possible,
// otherwise splits numbered / bulleted lines.
export const parseAiList = (text) => {
    const parsed = parseAiJson(text);
    if (Array.isArray(parsed)) {
        return parsed
            .map(item => (typeof item === 'string' ? item : item?.hook || item?.text || ''))
            .map(item => item.trim())
            .filter(Boolean);
    }
    if (typeof text !== 'string') return [];

    const listItem = /^\s*(?:\d+[.)]|[-*•])\s+/;
    let lines = text
        .replace(/```[a-z]*|```/gi, '')
        .split('\n')
        .filter(line => line.trim() && !/^\s*[[\]]\s*$/.test(line));

    // When the reply is a numbered / bulleted list, drop any intro or outro text
    if (lines.some(line => listItem.test(line))) {
        lines = lines.filter(line => listItem.test(line));
    }

    return lines
        .map(line => line.replace(listItem, '').trim().replace(/^["']|["'],?$/g, '').trim())
        .filter(Boolean);
};
